import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Stack, Drawer, Typography } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// config
import { NAV } from '../../../config-global';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
//
import navConfig from './config-navigation';
import NavAccount from './NavAccount';
import NavToggleButton from './NavToggleButton';
import AppVersion from './AppVersion';

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');
  const [navList] = useState<any>([...navConfig])
  const [navConfig1,setNavConfig] = useState<any>([])
  useEffect(()=>{
    function deepClone(obj:any) {
      if(typeof obj !=="object" || obj == null){
          return obj 
      }
      let res 
      if(obj instanceof Array){
          res = []
      }else{
          res = {}
      }

      for( var key in obj){
          if(obj.hasOwnProperty(key)){
            //@ts-ignore
              res[key] = deepClone(obj[key])
          }
      }
      return res
  }
    var arr: any = localStorage.getItem('menu')
    var arr1:any =deepClone(navList)
    console.log(arr1)
    if (arr) {
      var arr2: any = []
      arr = JSON.parse(arr)
      arr.forEach((v: any) => {
        v.sub_modules.forEach((value: any) => {
          arr2.push(value.name)
        })
        arr1[0].items.forEach((val: any) => {
          if (v.name === val.title || val.title=="首页") {
            val.stu = true
          }
        })
      })
      arr1[0].items.forEach((val: any) => {
        if (val.stu&&val.title!="首页") {
          val.children = val.children.filter((value: any, idx: number) => {
            return arr2.indexOf(value.title) != -1
          })
        }
      })
      arr1[0].items = arr1[0].items.filter((v: any) => v.stu === true)
      console.log('navConfig123',arr1)
      setNavConfig(arr1)
    }else{
      console.log('navConfig',navConfig)
      setNavConfig(navConfig)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
 
  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
        }}
      >
        <Stack
          direction={'row'}
          alignItems={"center"}
        >
        <Logo />
        <Typography variant="h5" component="h2">
            鱼吒Link
        </Typography>
      </Stack>
      <NavAccount />
      </Stack>
      <NavSectionVertical data={navConfig1} />

      <Box sx={{ flexGrow: 1 }} />

      <AppVersion />

      {/* <NavDocs /> */}
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
